import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const LogoutIcon = (props) => {
    const width = props.width ? props.width + 'px' : '28px';
    const height = props.height ? props.height + 'px' : '29px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 28 29"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path d="M18.1381 16.3998V12.4597H7.68142L11.8381 8.36729L9.00089 5.57812L0 14.4267L2.83717 17.2159L2.84336 17.2098L9.01328 23.2814L11.8504 20.4922L7.68761 16.3998H18.1381Z" />
            <path d="M19.8051 28.9939C24.2962 28.9756 27.9511 25.4009 27.9945 20.9857V20.9126V8.08736C28.0007 3.64175 24.3272 0.0182696 19.8051 0H19.7803H13.375V3.94624H19.7803C22.1033 3.94624 23.9865 5.80365 23.9865 8.08736V8.09954V20.9066C23.9865 20.9066 23.9865 20.9066 23.9865 20.9126C23.9865 23.2024 22.0971 25.0538 19.7803 25.0538H13.375V29H19.8051V28.9939Z" />
        </SvgStyled>
    );
};

export default LogoutIcon;
